module.exports = __webpack_public_path__ + "img/icon_accessControl.21ad7966.png";